import styled from "@emotion/styled";
import {Bindings} from "data/constants/bindings";
import {useViewController} from "data/services/locator";
import React, {useEffect, useRef} from "react";
import {observer} from "mobx-react";
import {Exist} from "views/components/exist/exist.component";
import {ITutorialSliderController} from "views/components/tutorial_slider/tutorial_slider.controller";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import {getIsIOS} from "data/utils";
import {TutorialSteps} from "views/components/tutorial_steps/tutorial_steps.component";
import {AdobeDTM} from "data/utils/AdobeDTM";

const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;

	.slick-arrow {
		display: none !important;
	}
`;

const StepContent = styled.div`
	height: 450px;
	display: inline-flex !important;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;

	img {
		width: 100%;
		height: auto;
		margin-bottom: 16px;
		border-radius: 10px;
	}

	> div {
		overflow: auto;
	}

	h3 {
		color: #fff;
		text-align: center;
		font-size: 20px;
		font-style: normal;
		font-weight: 600;
		line-height: 140%; /* 28px */
		margin-bottom: 16px;
	}

	.text {
		color: #fff;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 140%; /* 22.4px */
		text-align: left;
		height: auto;

		span,
		p,
		li {
			color: #fff;
			font-size: 16px;
			font-style: normal;
			font-weight: 400;
			line-height: 140%; /* 22.4px */
			text-align: left;
		}

		p {
			margin-bottom: 8px;
		}

		b {
			font-weight: bold;
		}

		ul {
			padding-left: 24px;
			list-style-type: disc;
		}
	}
`;

export const TutorialSlider: React.FC = observer(() => {
	const sliderRef = useRef<Slider>(null);
	const {i18n, steps, currentStep, goToStep} = useViewController<ITutorialSliderController>(
		Bindings.TutorialSliderController
	);

	useEffect(() => {
		if (sliderRef?.current) {
			sliderRef?.current?.slickGoTo(currentStep);
		}

		const currentStepData = steps[currentStep];
		if (!currentStepData) {
			return;
		}
		const stepHeading = i18n.t(currentStepData.title_loco, currentStepData.title_alt);

		AdobeDTM.trackAction({
			"action.name": `Spinball: Welcome Modal: Guide: ${stepHeading} Impression`,
		});
	}, [currentStep, sliderRef, i18n, steps]);

	return (
		<Wrapper>
			<Slider
				ref={sliderRef}
				adaptiveHeight={false}
				dots={false}
				infinite={false}
				speed={500}
				slidesToScroll={1}
				slidesToShow={1}
				useTransform={getIsIOS()}
				beforeChange={goToStep}>
				{steps.map((step, index) => (
					<StepContent key={index}>
						<Exist when={Boolean(step.image)}>
							<img src={step.image} alt={`step-${index}`} />
						</Exist>
						<h3
							// Disabled due html come from our BE and must be safety
							// eslint-disable-next-line
							dangerouslySetInnerHTML={{
								__html: i18n.t(step.title_loco, step.title_alt),
							}}
						/>

						<div
							className="text"
							// Disabled due html come from our BE and must be safety
							// eslint-disable-next-line
							dangerouslySetInnerHTML={{
								__html: i18n.t(step.text_loco, step.text_alt),
							}}
						/>
					</StepContent>
				))}
			</Slider>
			<TutorialSteps currentStep={currentStep} steps={steps} goToStep={goToStep} />
		</Wrapper>
	);
});
